/**
 * DependencyGrid Component
 * Responsive grid layout for dependency cards
 */

import React from 'react';
import { I18n } from 'react-redux-i18n';
import { HealthDependencies, LatencyHistoryEntry } from '../types';
import { DEPENDENCY_INFO } from '../constants';
import DependencyCard from './DependencyCard';
import styles from '../SystemHealth.module.css';

const I18N_PREFIX = 'systemSettings.systemHealth';

interface DependencyGridProps {
  dependencies: HealthDependencies;
  history: LatencyHistoryEntry[];
  isRefreshing?: boolean;
}

export const DependencyGrid: React.FC<DependencyGridProps> = ({
  dependencies,
  history,
  isRefreshing = false
}) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>{I18n.t(`${I18N_PREFIX}.sections.dependencies`)}</h3>
      <div className={styles.dependencyGrid}>
        {DEPENDENCY_INFO.map((info, index) => (
          <div 
            key={info.key} 
            className={styles.dependencyCardWrapper}
            style={{ animationDelay: `${index * 75}ms` }}
          >
            <DependencyCard
              dependencyKey={info.key}
              label={info.label}
              dependency={dependencies[info.key]}
              history={history}
              isRefreshing={isRefreshing}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DependencyGrid;
